import React from 'react'
import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import statement from "../../../Images/NewUI/bankimg.png";
import GreenCheck from "../../../Images/NewUI/greencheck.png";
import completeIMG from "../../../Images/superTick.png";
import upload from "../../../Images/upload.png";
import userline from "../../../Images/userline.png";
import tickimg from "../../../Images/verifycheckblack.png";
import { getUserDetail } from "../../../Redux/GeneralDetails/action";
import { getDocumentStatus, getWebViewEkycUrl, preSignedURL, upldateDocumentStatus, uploadDocsToS3 } from "../../../Redux/Manual_Kyc_Details/action";
import ToastMsg from "../../../helper/ToastMsg";
import "../../../styles/mandate.css";
import { Loader } from "../../NewUI/Common/Loader";
import Heading from "../Common/MainHeading";
import { HEADING_COMPLETEPROFILE } from "../Common/constant";

export function SelectKycProcess(props) {
  const navigate = useNavigate();
  const {setModalHide}= props
  const src_data = new URLSearchParams(window.location.search).get("src");

  const [eVerifyBtn, setVerifyBtn] = useState(true);
  const [mVerifyBtn, setMverifyBtn] = useState(false);
  const [eKycUrl, seteKycUrl] = useState("");
  const [loader, setLoader] = useState(false);
  

  useEffect(() => {
    let token = props.token||localStorage.getItem("gpay_token");
    props
      .getWebViewEkycUrl(token)
      .then((res) => {
        if (src_data === "assign_limit") {
          window.open(res.url, "_blank");
          navigate("/dashboard_s");
        }

        seteKycUrl(res.url);
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
          window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        // console.log(err);
      });
  }, []);
  const openUrl = () => {
    props.hanldeTimeInterval();
    window.open(eKycUrl, "_blank");
  };
  const proceed = () => {
    navigate("/complete_your_profile", { state: { stateChange: "no" } });
  };
  const eVerify = () => {
   
    setMverifyBtn(false);
    setVerifyBtn(true);
  };
  const mVerify = () => {
    setMverifyBtn(true);
    setVerifyBtn(false);
  };

  return (
    
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      
    >
      <Modal.Body>
        <div className="modal_body_new">
          <h3 className="modelheading ">Select KYC Process</h3>
          <div className="px-4 ">
            <div className="floatleft" style={{marginBottom:27}}>
            <input
              className="mr-4"
              type="radio"
              checked={eVerifyBtn}
              onChange={eVerify}
              id="EVerify"
            />
            <label className="modelLabel" htmlFor="EVerify">
              E-Verify
            </label>
            <p className="modelinputP">Get Your documents Verified Online</p>

            <input
              className="mr-4"
              type="radio"
              checked={mVerifyBtn}
              onChange={mVerify}
              id="MVerify"
            />
            <label className="modelLabel" htmlFor="MVerify">
              Manually Verify
            </label>
            <p className="modelinputP">
              Upload Your documents & get Verified Manually
            </p>
            </div>

            <div
              className="button-wrapper text-center"
              style={{ paddingTop: "25px" }}
            >
              {eVerifyBtn && !mVerifyBtn ? (
                <a
                  className="btn bg-orange text-white rounded-pill"
                  onClick={openUrl}
                >
                  Proceed
                </a>
              ) : !eVerifyBtn && mVerifyBtn ? (
                <a
                  className="btn bg-orange text-white rounded-pill"
                  onClick={proceed}
                  style={{ paddingTop: "2px", paddingBottom: "2px" }}
                >
                  Proceed
                </a>
              ) : (
                <a className="btn bg-orange text-white rounded-pill opacity-50">
                  Proceed
                </a>
              )}
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

function BankStatementModel(props) {
  const [bankstatement, setBankStatement] = useState([]);
  const [presigned_urls, setPresigned_urls] = useState({});

  useEffect(() => {
    let token = props.token||localStorage.getItem("gpay_token");
    let { id } = props.userDetail && props.userDetail.user_detail;
    let data = {
      s3_path: [`bank_statement/${id}/statement.pdf`],
    };
    props
      .preSignedURL({
        s3_path: data,
        token: token,
      })
      .then((res) => {
        setPresigned_urls(res);
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
          window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
      });
  }, []);

  const makeFormData = (result, pdf_value) => {
    let formData = new FormData();
    Object.keys(result.fields).forEach((key) => {
      let value = result.fields[key];
      formData.append(key, value);
    });
    formData.append("file", pdf_value);
    return formData;
  };

  const base64ToByteArray = (base64String) => {
    const byteCharacters = atob(base64String);
    var byteArray = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteArray[i] = byteCharacters.charCodeAt(i);
    }
    return new Uint8Array(byteArray);
  };

  const handleBankStatement = (e) => {
    fileToDataUri(e.target.files[0])
      .then((blob) => {
        uploadBankStatement(e.target.files[0]);
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
          window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        // console.log(err);
      });
  };

  const fileToDataUri = (file) => {
    const reader = new FileReader();

    return new Promise((resolve, reject) => {
      reader.onload = () => {
        const blob = new Blob([reader.result], { type: file.type });
        resolve(blob);
      };

      reader.onerror = () => {
        reject(reader.error);
      };

      reader.readAsArrayBuffer(file);
    });
  };
  const uploadBankStatement = (blob) => {
    let { id } = props.userDetail && props.userDetail.user_detail;
    let token = props.token;
    let data = {
      image_path: `bank_statement/${id}/statement.pdf`,
      token: token,
    };
    let bs_presigned_data = presigned_urls;
    let bs_data = bs_presigned_data.data[`bank_statement/${id}/statement.pdf`];
    if (bs_presigned_data) {
      let formData = makeFormData(bs_data, blob);
      formData.append("key", data.image_path);
      props
        .uploadDocsToS3({
          url: bs_data.url,
          formData,
        })
        .then((res) => {
          if (res.status === 204) {
            let data = {
              doc_type: "bank_statement",
              path: `bank_statement/${id}/statement.pdf`,
            };
            props
              .upldateDocumentStatus({
                updateStatus: data,
                token: token,
              })
              .then((res) => {
                if (res) {
                  props.handleStatus();
                  props.onHide();
                }
              })
              .catch((err) => {
                setLoader(false);
                if (err.response?.status === 401) {
                  window.location.href = "/";
                  localStorage.removeItem("gpay_token");
                }
                let error = err?.response?.data?.error;
                ToastMsg(error, "error");
              });
          }
        })
        .catch((err) => {
          setLoader(false);
          if (err.response?.status === 401) {
            window.location.href = "/";
            localStorage.removeItem("gpay_token");
          }
          let error = err?.response?.data?.error;
          ToastMsg(error, "error");
        });
    }
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      
    >
      <Modal.Body>
        <h3 className="modelheading2">
          Please provide us with your bank Statement
        </h3>
        <p>select one to continue</p>
        <div className="px-4">
          <div className="#">
            <Link to="/sahamati" >
              <button className="jigbuttonModel">
                <img src={upload} height="30" className="px-4"/>
                E-Statement
              </button>
            </Link>
          </div>
          <div
            className="jigbuttonModeltwo"
            style={{ position: "relative", padding: "15px 25px" }}
          >
            <input
              accept="application/pdf"
              type="file"
              onChange={handleBankStatement}
              style={{
                width: "100%",
                position: "absolute",
                opacity: "0",
                height: "63px",
                top: "0",
                left: "0",
              }}
            />
            <img src={upload} height="30" className="px-4" />
            Upload Statement
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

const CompleteProfilenew = (props) => {
  const navigate = useNavigate();
  let token = props?.user?.User?.token || localStorage.getItem("gpay_token");
  const [state, setState] = useState({
    modalShow: false,
    bankModelShow: false,
    kyc_verified: "",
    bank_details_verified: "",
    bank_statement_verified: "",
    professional_details_verified: "",
    adhar_card_verified: "",
    pan_card_verified: "",
    isLoading: false,
    loader: false,
    kycmodel: false,
  });
  const [startInterval, setStartInterval] = useState(false);
  var time_interval;

  useEffect(() => {
    handleStatus();
    if (startInterval) {
      time_interval = setInterval(() => {
        handleStatus();
      }, 3000);
    }
  }, [startInterval]);

  const handleStatus = () => {
    setState({ loader: true });
    props
      .getDocumentStatus(token)
      .then((res) => {
        setState({ loader: false });
        res.data.map((item) => {
          return setState((prev)=>({...prev,
            kyc_verified: item.kyc_verified,
            bank_details_verified: item.bank_details_verified,
            bank_statement_verified: item.bank_statement_verified,
            professional_details_verified: item.professional_details_verified,
            isLoading: false,
          }))
        });
      })
      .catch((err) => {
        setState({loader:false});
        if (err.response?.status === 401) {
          window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
      });
  };

  const setModalShow = () => {
    setState((prevstate)=>({...prevstate,  modalShow: !state.modalShow }));
  };
  
  const setModalHide = () => {
    setState((prevstate)=>({...prevstate,  modalShow: false }))
  };

  useEffect(() => {  
    if(state?.modalShow){
      window.location.reload()
    }
  }, [setState]);

  const setBankModelShow = () => {
    setState((prev)=>({ ...prev, bankModelShow: true }));
  };
  const setBankModelHide = () => {
    setState((prev)=>({ ...prev, bankModelShow: false }));
   
  };
  const hanldeTimeInterval = () => {
    setStartInterval(true);
  };

  return (
    
   <>
  {state.loader ? (
          <div className="loader_cl">
            <Loader />
          </div>
        ) : null}
       
    <div className="container">
      <SelectKycProcess
        show={state.modalShow}
        onHide={setModalShow}
        
        getWebViewEkycUrl={props.getWebViewEkycUrl}
        token={token}
        history={props.history}
        hanldeTimeInterval={hanldeTimeInterval}
        onExit={()=>{console.log("dsosm")}}
      onBackdropClick={()=>{console.log("dsosm")}}
      />

      <div className="pb-4">
        <div className="shadowline marginbottom">
        <Heading
          headingText={HEADING_COMPLETEPROFILE}
          history={props.history}
        />
        </div>
        
        <div className="wrapper-content">
          <div className="overflow finalfix px-4  py-4 w-100  text-black bg-new shadowcard rounder-10 ">
            <div className="  d-flex flex-column justify-content-between">
              <h3 className="benefits-h text-black">Benefits</h3>
              <div className="pt-2">
                <img width="16px" height="16px" src={tickimg} />
                <span className="benefits-p">Instant loan upto 2,00,000.</span>
              </div>
              <div className="pt-2">
                <img width="16px" height="16px" src={tickimg} />
                <span className="benefits-p">100% paperless process.</span>
              </div>
              <div className="pt-2">
                <img width="16px" height="16px" src={tickimg} />
                <span className="benefits-p">
                  Easy and flexible repayment options.
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="px-6 pt-4">
          <div className="profilelowersec ">
          {state.bank_statement_verified === "NOT_SUBMITTED"  ?  <img width={58} src={statement} /> :  <img width={58} src={GreenCheck}/>}
            <div className="pt-3 px-2 ">
              <h3>Bank statement</h3>
              <p>
                Provide your latest bank account statement for faster completion
                of your loan application and disbursal.
              </p>
              {state.bank_statement_verified === "NOT_SUBMITTED"  ? (
                <Link to="/bank_details">
                <div  className="continue_btn continue_btn_margin">
                  Continue
                </div>
                </Link>
              ) : (
                <div  className="continue_btn  continue_btn_margin" style={{opacity: "0.5" }}>
                  Continue
                </div>
              )}


               {state.bank_details_verified === "NOT_SUBMITTED" ? (
                <>
                  {" "}
                  {state.bank_statement_verified === "NOT_SUBMITTED" ? (
                    <button className="jigbutton opacity-50">Continue</button>
                  ) : (
                    ""
                  )}{" "}
                </>
              ) : (
                ""
              )} 
               {state.bank_statement_verified === "VERIFIED" ? (
                <div className="verified_details">
                  <p
                    style={{
                      color: "#02C650",
                      fontSize: 14,
                      fontWeight: 600,
                    }}
                  >
                    

                    <img
                      src={completeIMG}
                      alt="paymeindia"
                      width="18"
                      style={{
                        verticalAlign: "middle",
                        marginRight: 5,
                        marginTop: -5,
                      }}
                    />
                    <span>Completed</span>
                  </p>
                </div>
              ) : (
                ""
              )}
              {state.bank_statement_verified === "PENDING_VERIFICATION" ? (
                <div>
                  <div className="dot"></div> <span>pending</span>
                  <button className="jigbutton" onClick={setBankModelShow}>
                    Change
                  </button>
                </div>
              ) : (
                ""
              )}
              {state.bank_statement_verified === "NOT_VALID" ? (
                <div className="verified_details">
                  <i
                    className="fa fa-check-circle"
                    aria-hidden="true"
                    style={{ color: "#DE0000" }}
                  ></i>
                  <p
                    style={{
                      color: "#DE0000",
                      fontSize: 14,
                      fontWeight: 600,
                      paddingLeft: "0.3em",
                      float: "left",
                    }}
                  >
                    Not Valid
                  </p>{" "}
                  <button className="jigbutton" onClick={setBankModelShow}>
                    Change
                  </button>
                </div>
              ) : (
                ""
              )} 
            </div>
          </div>

          <div className="profilelowersec ">
            <img src={userline} 
            style={{
              width: 58,
              height: 58,
            }}/>
            <div className="pt-3 px-2 ">
              <h3>Professional details</h3>
              <p>
                Kindly provide your professional details to complete your
                profile.
              </p>
              {state.professional_details_verified === "NOT_SUBMITTED" &&
              state.bank_statement_verified !== "NOT_SUBMITTED" ? (
                <div
                  className="continue_btn continue_btn_margin"
                  onClick={() =>
                    navigate("/completeprofilescreenone")
                  }
                >
                  Continue
                </div>
              ) : (
                ""
              )}
              {state.bank_statement_verified === "NOT_SUBMITTED" ? (
                <>
                  {" "}
                  {state.professional_details_verified === "NOT_SUBMITTED" ? (
                    <div className="continue_btn continue_btn_margin opacity-50">Continue</div>
                  ) : (
                    ""
                  )}{" "}
                </>
              ) : (
                ""
              )}
              {state.professional_details_verified === "VERIFIED" ? (
                <div className="verified_details">
                  <p
                    style={{
                      color: "#02C650",
                      fontSize: 14,
                      fontWeight: 600,
                    }}
                  >
                    <img
                      src={completeIMG}
                      alt="paymeindia"
                      width="18"
                      style={{
                        verticalAlign: "middle",
                        marginRight: 5,
                        marginTop: -5,
                      }}
                    />
                    <span>Completed</span>
                  </p>
                </div>
              ) : (
                ""
              )}
              {state.professional_details_verified ===
              "PENDING_VERIFICATION" ? (
                <div>
                  <div className="dot"></div> <span>pending</span>
                  <button
                    className="continue_btn continue_btn_margin"
                    onClick={() =>
                      navigate("/completeprofilescreenone")
                    }
                  >
                    Change
                  </button>
                </div>
              ) : (
                ""
              )}
              {state.professional_details_verified === "NOT_VALID" ? (
                <div className="verified_details">
                  <i
                    className="fa fa-check-circle"
                    aria-hidden="true"
                    style={{ color: "#DE0000" }}
                  ></i>
                  <p
                    style={{
                      color: "#DE0000",
                      fontSize: 14,
                      fontWeight: 600,
                      paddingLeft: "0.3em",
                      float: "left",
                    }}
                  >
                    Not Valid
                  </p>{" "}
                  <button
                    className="jigbutton"
                    onClick={() =>
                      navigate("/completeprofilescreenone")
                    }
                  >
                    Change
                  </button>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>

      {token !== "" ? (
        <BankStatementModel
          onHide={setBankModelHide}
          show={state?.bankModelShow}
          preSignedURL={props?.preSignedURL}
          uploadDocsToS3={props?.uploadDocsToS3}
          upldateDocumentStatus={props?.upldateDocumentStatus}
          token={token}
          history={props?.history}
          userDetail={props?.userDetail}
          handleStatus={handleStatus}
        />
      ) : (
        ""
      )}
    </div></>
  );
};
const mapStateToProps = (state) => {
  return {
    user: state.user,
    userDetail: state.userDetail,
  };
};

export default connect(mapStateToProps, {
  getWebViewEkycUrl,
  getDocumentStatus,
  getUserDetail,
  preSignedURL,
  uploadDocsToS3,
  upldateDocumentStatus,
})(CompleteProfilenew);